export default "__VITE_ASSET__C$V6dIlp__"